<template>
    <div v-fs-block>
        <div class="btn-group">
            <v-popper2 position="bottomEnd" :state="showCalendarPopper">
                <template #trigger="{popper}">
                    <button class="btn" @click="popper.toggle()">
                        <v-icon class="inline-s" icon="calendar"></v-icon>
                        {{periodLabel}}
                    </button>
                </template>
                <template #content>
                    <div class="dropdown" style="width:513px">
                        <v-calendar-manager type="range" @input="periodChange" :value="period"/>
                    </div>
                </template>
            </v-popper2>
            <v-popper2 position="bottomEnd">
                <template #trigger="{popper}">
                    <button class="btn has-icon no-flex" @click="popper.toggle">
                        <v-icon icon="actions"/>
                    </button>
                </template>
                <template #content>
                    <div class="dropdown">
                        <div class="dropdown-content">
                            <a
                                class="dropdown-item"
                                v-for="presetName in periodPresetOptions"
                                :key="presetName"
                                @click="selectPreset(presetName)"
                            >
                                <strong>{{getPresetLabel(presetName)}}&nbsp;</strong>
                                <span class="text-muted" v-html="getFormattedPresetPeriod(presetName)"></span>
                            </a>
                        </div>
                    </div>
                </template>
            </v-popper2>
        </div>
    </div>
</template>
<script>
    import {DateTimeFormats} from '@/common/datetime-formats';
    import vIcon from '@/components/form/v-icon';
    import vPopper2 from '@/components/popper/v-popper2';
    import vCalendarManager from './v-calendar-manager';
    import calendarPresets, {calendarPresetsLabels, calendarPresetsPeriods} from './calendar-presets';

    export default {
        components: {
            vIcon,
            vPopper2,
            vCalendarManager,
        },
        props: {
            value: {
                type: Object,
            },
        },
        computed: {
            periodLabel() {
                const format = date => this.$filters.dateLocal(date, DateTimeFormats.shortDate);
                return `${format(this.period.start)} — ${format(this.period.end)}`;
            },
        },
        data() {
            return {
                period: this.value,
                popupOptions: {
                    placement: 'bottom-end',
                    modifiers: {
                        offset: {
                            offset: '0, 4',
                        },
                        computeStyle: {
                            x: 'bottom',
                            y: 'right',
                        },
                    },
                },
                showCalendarPopper: false,
                periodPresetOptions: Object.keys(calendarPresets),
            };
        },
        methods: {
            togglePopper(name) {
                this[`show${name}Popper`] = !this[`show${name}Popper`];
            },
            updatePeriod(data) {
                this.period = {...data};
                this.$emit('input', {...data});
            },
            periodChange(data) {
                this.showCalendarPopper = false;
                this.$nextTick(() => { this.showCalendarPopper = null; });
                this.updatePeriod(data);
            },
            getPresetLabel(presetName) {
                return calendarPresetsLabels[presetName];
            },
            getFormattedPresetPeriod(presetName) {
                const period = calendarPresetsPeriods[presetName](this.$tz());
                const formatter = value => this.$filters.dateLocal(value, DateTimeFormats.shortDate);
                return `${formatter(period.start)} — ${formatter(period.end)}`;
            },
            selectPreset(presetName) {
                this.updatePeriod(calendarPresetsPeriods[presetName](this.$tz()));
            },
        },
    };
</script>
